// Generic, config-driven mega-menu definitions.
// Each entry = one nav trigger. `sections` renders in the left sidebar of the
// split panel; the active section's `links` render on the right.
// This same shape can power any trigger (secondary course nav today, and the
// primary right-hand nav links in future) — just pass a config entry to <MegaMenu/>.
//
// NOTE: Course links only reference courses we actually have data for
// (MBBS, BDS, BHMS, BSc_Nursing, BVSc). Courses without data (BAMS, MDS,
// Pharmacy, BPT) are intentionally omitted.

export const COURSE_MEGA_MENUS = [
  {
    id: "medical",
    label: "Medical",
    sections: [
      {
        id: "top-ranked",
        label: "Top Ranked Colleges",
        links: [
          { label: "Top Medical Colleges in India", to: "/colleges?course=MBBS" },
          { label: "Top Medical Colleges in Karnataka", to: "/colleges?course=MBBS&state=Karnataka" },
          { label: "Top Medical Colleges in Maharashtra", to: "/colleges?course=MBBS&state=Maharashtra" },
          { label: "Top Medical Colleges in Bangalore", to: "/colleges?course=MBBS&q=Bangalore" },
          { label: "Top Medical Colleges in Mumbai", to: "/colleges?course=MBBS&q=Mumbai" },
          { label: "Top Medical Colleges in Delhi", to: "/colleges?course=MBBS&state=Delhi" },
        ],
      },
      {
        id: "popular-courses",
        label: "Popular Courses",
        links: [
          { label: "MBBS", to: "/colleges?course=MBBS" },
          { label: "BDS", to: "/colleges?course=BDS" },
          { label: "BHMS", to: "/colleges?course=BHMS" },
          { label: "B.Sc Nursing", to: "/colleges?course=BSc_Nursing" },
        ],
      },
      {
        id: "by-location",
        label: "Colleges By Location",
        links: [
          { label: "Medical Colleges in Karnataka", to: "/colleges?state=Karnataka" },
          { label: "Medical Colleges in Maharashtra", to: "/colleges?state=Maharashtra" },
          { label: "Medical Colleges in Tamil Nadu", to: "/colleges?state=Tamil Nadu" },
          { label: "Medical Colleges in Uttar Pradesh", to: "/colleges?state=Uttar Pradesh" },
          { label: "Medical Colleges in Delhi", to: "/colleges?state=Delhi" },
          { label: "Medical Colleges in West Bengal", to: "/colleges?state=West Bengal" },
        ],
      },
      {
        id: "predictors",
        label: "Rank Predictors",
        links: [
          { label: "NEET UG College Predictor", to: "/ug-neet/predict" },
          { label: "NEET Rank Predictor", to: "/ug-neet/predict" },
        ],
      },
      {
        id: "resources",
        label: "Resources",
        links: [
          { label: "Counselling Tracker", to: "/counselling" },
          { label: "Browse All Colleges", to: "/colleges" },
        ],
      },
    ],
  },
  {
    id: "dental",
    label: "Dental",
    sections: [
      {
        id: "top-ranked",
        label: "Top Ranked Colleges",
        links: [
          { label: "Top Dental Colleges in India", to: "/colleges?course=BDS" },
          { label: "Top Dental Colleges in Karnataka", to: "/colleges?course=BDS&state=Karnataka" },
          { label: "Top Dental Colleges in Maharashtra", to: "/colleges?course=BDS&state=Maharashtra" },
        ],
      },
      { id: "courses", label: "Popular Courses", links: [{ label: "BDS", to: "/colleges?course=BDS" }] },
    ],
  },
  {
    id: "ayush",
    label: "Ayush",
    sections: [
      {
        id: "top-ranked",
        label: "Top Ranked Colleges",
        links: [
          { label: "Top Homeopathy (BHMS) Colleges in India", to: "/colleges?course=BHMS" },
        ],
      },
    ],
  },
  {
    id: "allied",
    label: "Allied Health",
    sections: [
      {
        id: "top-ranked",
        label: "Top Ranked Colleges",
        links: [
          { label: "Top Nursing (B.Sc) Colleges in India", to: "/colleges?course=BSc_Nursing" },
          { label: "Top Veterinary (B.V.Sc) Colleges in India", to: "/colleges?course=BVSc" },
        ],
      },
    ],
  },
  {
    id: "all-courses",
    label: "All Courses",
    sections: [
      {
        id: "browse",
        label: "Browse",
        links: [
          { label: "All Colleges", to: "/colleges" },
          { label: "MBBS Colleges", to: "/colleges?course=MBBS" },
          { label: "BDS Colleges", to: "/colleges?course=BDS" },
          { label: "BHMS Colleges", to: "/colleges?course=BHMS" },
          { label: "B.Sc Nursing Colleges", to: "/colleges?course=BSc_Nursing" },
          { label: "College Predictor", to: "/ug-neet/predict" },
          { label: "Counselling Tracker", to: "/counselling" },
        ],
      },
    ],
  },
];
